import { TableCell } from "@mui/material";
import { ServiceProvided } from "../../types";
import {
	activeServicesProvidedFilter,
	finishedServicesProvidedFilter,
	plannedServicesProvidedFilter,
} from "../../utils";
import { CustomChip } from "../../../../../components/chips/CustomChip";
import { makeMockFormatedFieldDropDown } from "../../../../../utils/formatFields";

type ServiceProvidedStatusTableCellProps = {
	serviceProvided: ServiceProvided;
};

export const ServiceProvidedStatusTableCell = ({ serviceProvided }: ServiceProvidedStatusTableCellProps) => {
	const isServProvActive = activeServicesProvidedFilter(serviceProvided);
	const isServProvFinished = finishedServicesProvidedFilter(serviceProvided);
	const isServProvPlanned = plannedServicesProvidedFilter(serviceProvided);

	let status = "";
	if (isServProvActive) status = "A Decorrer";
	if (isServProvFinished) status = "Concluído";
	if (isServProvPlanned) status = "Planeado";

	const mockFormatedField = makeMockFormatedFieldDropDown([{ text: status, value: status }], [{ foreground: "primary.main", background: '', value: "A Decorrer" }]);

	return (
		<TableCell align="center">
			<CustomChip field={mockFormatedField} label={status} />
		</TableCell>
	);
};